import { render, staticRenderFns } from "./Versioninfo.vue?vue&type=template&id=171ea5df&scoped=true"
import script from "./Versioninfo.vue?vue&type=script&lang=ts"
export * from "./Versioninfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.11.0_webpack@5.109.2__ejs@3.1.10_hand_b7975ec27586492790fee85183072e80/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171ea5df",
  null
  
)

export default component.exports